import { animateElement, Duration, TransitionStopReason } from 'utils/animateElement';

import { COLLAPSED_STYLE } from '../constants';
import { cleanUpExpand } from './cleanUpExpand';
import { createExpandedStyle } from './createExpandedStyles';

export const animateExpand = async (
  element: HTMLElement,
  toContentHeight: number,
  duration: Duration,
) => {
  const expandedStyle = createExpandedStyle(toContentHeight);
  const reason = await animateElement(COLLAPSED_STYLE, expandedStyle, element, duration);
  if (reason === TransitionStopReason.end) cleanUpExpand(element);
};
